/* ============
 * EDI Order Item Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/ediOrderItem/state.js